import { useTranslation } from '../hooks/useTranslation'
import { moneyParts } from '../lib/format'

/**
 * An amount the way a customer should read it: the figure carries the size,
 * the currency sits smaller beside it, and ".00" is left off a whole amount.
 * Inherits size and colour from where it is used, so the unit keeps the
 * figure's contrast. `lead` is for the big figures, where it steps further down.
 */
export default function Money({ amount, currency, lead = false }: { amount: number; currency: string; lead?: boolean }) {
  const { locale } = useTranslation()
  return (
    <span className="whitespace-nowrap tabular-nums">
      {moneyParts(amount, currency, locale).map((part, i) =>
        part.unit ? (
          <span key={i} className={`font-volte ${lead ? 'text-[0.6em]' : 'text-[0.85em]'}`}>
            {part.value}
          </span>
        ) : (
          <span key={i}>{part.value}</span>
        ),
      )}
    </span>
  )
}
